import { useState } from "react";
import { features } from "../../data/mock";
import { Card } from "../ui/card";
import {
  BarChart3, CreditCard, BookOpen, Play,
  Heart, GraduationCap, HandHeart, LayoutDashboard
} from "lucide-react";

const iconMap = {
  BarChart3: BarChart3,
  CreditCard: CreditCard,
  BookOpen: BookOpen,
  Play: Play,
  Heart: Heart,
  GraduationCap: GraduationCap,
  HandHeart: HandHeart,
  LayoutDashboard: LayoutDashboard
};

export const FeaturesSection = () => {
  const [activeFeature, setActiveFeature] = useState(null);

  return (
    <section id="features" className="relative py-28 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-[#f0f9ff]" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-brand-200/30 rounded-full blur-3xl" />
      <div className="absolute bottom-20 right-0 w-[300px] h-[300px] bg-brand-100/40 rounded-full blur-3xl" />

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-20">
          <span className="inline-block px-5 py-2 rounded-full bg-brand-100 border border-brand-200 text-brand-700 text-xs font-bold uppercase tracking-widest mb-5 brand-heading">
            Todo en un Solo Lugar
          </span>
          <h2 className="brand-heading text-4xl md:text-5xl lg:text-6xl font-bold text-slate-800 mb-5">
            Herramientas para tu Ministerio
          </h2>
          <p className="text-slate-500 text-lg max-w-2xl mx-auto leading-relaxed">
            Módulos y herramientas completamente personalizables para cada congregación
            con un manejo intuitivo e innovador.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((feature) => {
            const Icon = iconMap[feature.icon];
            const isActive = activeFeature === feature.id;

            return (
              <Card
                key={feature.id}
                className={`group relative p-6 rounded-3xl border cursor-pointer transition-all duration-500 hover:-translate-y-2 ${
                  isActive
                    ? "bg-brand-700 border-brand-600 shadow-2xl shadow-brand-700/25"
                    : "bg-white border-brand-100 hover:border-brand-300 hover:shadow-xl hover:shadow-brand-700/8"
                }`}
                onClick={() => setActiveFeature(isActive ? null : feature.id)}
              >
                {/* Icon */}
                <div
                  className={`w-13 h-13 rounded-2xl flex items-center justify-center mb-5 transition-all duration-300 group-hover:scale-110 ${
                    isActive
                      ? "bg-brand-light/20"
                      : "bg-brand-50 group-hover:bg-brand-100"
                  }`}
                  style={{ width: '52px', height: '52px' }}
                >
                  <Icon
                    className={`w-6 h-6 transition-colors duration-300 ${
                      isActive ? "text-brand-light" : "text-brand-700"
                    }`}
                  />
                </div>

                {/* Title */}
                <h3
                  className={`brand-heading text-lg font-bold mb-3 transition-colors duration-300 ${
                    isActive ? "text-white" : "text-slate-800"
                  }`}
                >
                  {feature.title}
                </h3>

                {/* Description */}
                <p
                  className={`text-sm leading-relaxed mb-4 transition-colors duration-300 ${
                    isActive ? "text-white/70" : "text-slate-500"
                  }`}
                >
                  {feature.description}
                </p>

                {/* Verse */}
                <div
                  className={`pt-4 border-t transition-colors duration-300 ${
                    isActive ? "border-white/10" : "border-brand-100"
                  }`}
                >
                  <p
                    className={`text-xs italic leading-relaxed transition-colors duration-300 ${
                      isActive ? "text-white/40" : "text-slate-400"
                    }`}
                  >
                    {feature.verse}
                  </p>
                  <p
                    className={`text-xs mt-1 font-bold transition-colors duration-300 ${
                      isActive ? "text-brand-light/60" : "text-brand-700/50"
                    }`}
                  >
                    {feature.verseRef}
                  </p>
                </div>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};
